//import React from "react"
import firebase from 'firebase';

export class GetManyReferenceService {
  getManyReference = (resource, params) => {
    console.log('getManyReference', resource, params);

    const getList = collection => {
      return firebase
        .database()
        .ref(collection)
        .once('value')
        .then(snapshot => snapshot.val());
    };

    // return Promise.all([getList("users"), getList("events")]).then(([users, events]) => {
    //   const objectToArrayWithId = values =>
    //     Object.entries(values).map(value =>
    //       Object.assign({}, { id: value[0] }, value[1])
    //     );

    //   const selectedUser = objectToArrayWithId(users).find(
    //     user => user.id === params.id
    //   );
    //   const eventsWithId = objectToArrayWithId(events);

    //   if (selectedUser.eventIds) {
    //     const eventsByUser = selectedUser.eventIds.map(eventId =>
    //       eventsWithId.filter(event => event.id === eventId)
    //     );

    //     const eventsByUserReduced = eventsByUser.reduce((newArray, event) => {
    //       return newArray.concat(event);
    //     }, []);

    //     return { data: eventsByUserReduced, total: eventsByUserReduced.length };
    //   }

    //   return { data: [], total: 0 };
    // });

    if (params.target === 'eventIds') {
      return Promise.all([
        getList('users'),
        getList('events'),
        getList('missions')
      ]).then(([users, events, missions]) => {
        const objectToArrayWithId = values =>
          Object.entries(values).map(value =>
            Object.assign({}, { id: value[0] }, value[1])
          );

        const selectedUser = objectToArrayWithId(users).find(
          user => user.id === params.id
        );
        const eventsWithId = objectToArrayWithId(events);

        let response = [];

        if (selectedUser.eventIds) {
          const eventsByUser = selectedUser.eventIds.map(eventId =>
            eventsWithId.filter(event => event.id === eventId)
          );

          const eventsByUserReduced = eventsByUser.reduce((newArray, event) => {
            return newArray.concat(event);
          }, []);

          response = eventsByUserReduced;
        }

        return { data: response, total: response.length };
      });
    } else if (params.target === 'missionIds') {
      return Promise.all([getList('users'), getList('missions')]).then(
        ([users, missions]) => {
          const objectToArrayWithId = values =>
            Object.entries(values).map(value =>
              Object.assign({}, { id: value[0] }, value[1])
            );

          const selectedUser = objectToArrayWithId(users).find(
            user => user.id === params.id
          );
          const missionsWithId = objectToArrayWithId(missions);

          let response = [];

          if (selectedUser.missionIds) {
            const missionsByUser = selectedUser.missionIds.map(missionId =>
              missionsWithId.filter(mission => mission.id === missionId)
            );

            const missionsBuUserReduced = missionsByUser.reduce(
              (newArray, mission) => {
                return newArray.concat(mission);
              },
              []
            );

            response = missionsBuUserReduced;
          }

          return { data: response, total: response.length };
        }
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/GetManyReferenceService.js